export * from "./companyDepartmentDataMap"
export * from "./preferredMeasurementDataMap"
export * from "./companyRouteNames"

export const COMPANY_TYPE = {
  SUPPLIER: "COMMODITY_VENDOR",
  CUSTOMER: "CUSTOMER",
  TRANSPORTATION: "TRANSPORTATION",
  MISC: "MISC",
  AKROCHEM_WAREHOUSE: "AKROCHEM_WAREHOUSE",
  CONSIGNMENT_WAREHOUSE: "CONSIGNMENT_WAREHOUSE",
  VENDOR: "VENDOR",
}
